/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import DescriptionIcon from "@material-ui/icons/Description";
import LanguageIcon from "@material-ui/icons/Language";
import { shallowEqual, useSelector } from "react-redux";
import {
  Category,
  Class,
  ContactMail,
  Description,
  Event,
  EventAvailable,
  GroupWork,
  Help,
  Label,
  Landscape,
  Link as LinkIcon,
  LocationCity,
  Mail,
  Person,
  Public,
  School,
  Search,
  SupervisorAccount,
} from "@material-ui/icons";
import {
  BookOpenText,
  BriefcaseBusiness,
  Contact,
  Flag,
  Image,
  Newspaper,
  Stamp,
  CreditCard,
} from "lucide-react";
import {
  showBannersImagenesMenu,
  showMiscConfigMenu,
  showPaymentMenu,
  isCongresoDelegado,
} from "../../../../../_helpers/backofficePermissions";

export function AsideMenuList({ layoutProps }) {
  const user = useSelector((store) => store.authentication?.user, shallowEqual);
  const location = useLocation();

  // Estado para controlar qué secciones están expandidas (por defecto: USERS abierto, demás cerradas)
  const [expandedSections, setExpandedSections] = useState({
    users: true,
    congresos: false,
    contenido: false,
    noticias: false,
    miscellany: false,
  });

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };
  const getMenuItemActive = (url, hasSubmenu = false, excludePaths = []) => {
    const current = location.pathname.split(/[?#]/)[0];

    // Si hay rutas a excluir, verificar que no estemos en ninguna de ellas
    if (excludePaths.length > 0) {
      const isExcluded = excludePaths.some(
        (excludePath) =>
          current === excludePath || current.indexOf(excludePath) > -1,
      );
      if (isExcluded) return "";
    }

    return checkIsActive(location, url)
      ? ` ${!hasSubmenu &&
          "menu-item-active"} menu-item-open menu-item-not-hightlighted`
      : "";
  };

  // Función especial para Users que excluye cuando estamos en Socios
  const getUsersMenuItemActive = (hasSubmenu = false) => {
    const current = location.pathname.split(/[?#]/)[0];
    // Si estamos en socios, no marcar Users como activo
    if (current === "/socios" || current.indexOf("/socios") > -1) {
      return "";
    }
    // Si estamos en edit-user, verificar si venimos de socios (usando state o localStorage)
    if (current === "/edit-user" || current.indexOf("/edit-user") > -1) {
      const fromSocios =
        location.state?.fromSocios ||
        (typeof window !== "undefined" &&
          localStorage.getItem("editUserFromSocios") === "true");
      if (fromSocios) {
        return "";
      }
    }
    return (
      getMenuItemActive("/users", hasSubmenu) ||
      getMenuItemActive("/edit-user", hasSubmenu)
    );
  };

  // Función especial para Socios que verifica si venimos de socios cuando estamos en edit-user
  const getSociosMenuItemActive = (hasSubmenu = false) => {
    const current = location.pathname.split(/[?#]/)[0];
    // Si estamos en edit-user, verificar si venimos de socios (usando state o localStorage)
    if (current === "/edit-user" || current.indexOf("/edit-user") > -1) {
      const fromSocios =
        location.state?.fromSocios ||
        (typeof window !== "undefined" &&
          localStorage.getItem("editUserFromSocios") === "true");
      if (fromSocios) {
        return (
          getMenuItemActive("/socios", hasSubmenu) ||
          getMenuItemActive("/edit-user", hasSubmenu)
        );
      }
    }
    return (
      getMenuItemActive("/socios", hasSubmenu) ||
      getMenuItemActive("/edit-user", hasSubmenu)
    );
  };

  if (isCongresoDelegado(user?.role)) {
    return (
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        <li
          className={`menu-item ${getMenuItemActive("/congresos", false, [
            "/congresos/sitio-web",
          ])}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/congresos">
            <span className="menu-icon">
              <GroupWork />
            </span>
            <span className="menu-text">Ediciones</span>
          </NavLink>
        </li>
        <li className={`menu-item ${getMenuItemActive("/congresos/sitio-web", false)}`}>
          <NavLink className="menu-link" to="/congresos/sitio-web">
            <span className="menu-icon">
              <LinkIcon />
            </span>
            <span className="menu-text">URL web congresos</span>
          </NavLink>
        </li>
      </ul>
    );
  }

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        <li
          className={`menu-item ${getMenuItemActive("/dashboard", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dashboard">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")} />
            </span>
            <span className="menu-text">Dashboard</span>
          </NavLink>
        </li>
        <li
          className="menu-section"
          style={{ cursor: "pointer" }}
          onClick={() => toggleSection("users")}
        >
          <h4 className="menu-text">USERS</h4>
          {expandedSections.users ? (
            <i
              className="menu-icon ki ki-bold-triangle-top icon-sm"
              style={{ display: "flex", marginLeft: "auto" }}
            ></i>
          ) : (
            <i
              className="menu-icon ki ki-bold-triangle-bottom icon-sm"
              style={{ display: "flex", marginLeft: "auto" }}
            ></i>
          )}
        </li>
        {expandedSections.users && (
          <>
            {user.role !== "user" && user.role !== "docente" && (
              <li
                className={`menu-item ${getMenuItemActive(
                  "/admins",
                  false,
                )} ${getMenuItemActive("/edit-admin", false)}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/admins">
                  <span className="menu-icon">
                    <SupervisorAccount />
                  </span>
                  <span className="menu-text">Administrators</span>
                </NavLink>
              </li>
            )}
            <li
              className={`menu-item ${getUsersMenuItemActive(false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/users">
                <span className="menu-icon">
                  <AssignmentIndIcon />
                </span>
                <span className="menu-text">Users</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getSociosMenuItemActive(false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/socios">
                <span className="menu-icon">
                  <Contact />
                </span>
                <span className="menu-text">Socios</span>
              </NavLink>
            </li>
            {showPaymentMenu(user.role) && (
              <>
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/payment-operations",
                    false,
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/payment-operations">
                    <span className="menu-icon">
                      <CreditCard />
                    </span>
                    <span className="menu-text">Gestión de Pagos</span>
                  </NavLink>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/payment-management",
                    false,
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/payment-management">
                    <span className="menu-icon">
                      <CreditCard />
                    </span>
                    <span className="menu-text">Gestión de Migraciones</span>
                  </NavLink>
                </li>
              </>
            )}
            <li
              className={`menu-item ${getMenuItemActive(
                "/docentes",
                false,
              )} ${getMenuItemActive("/edit-docente", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/docentes">
                <span className="menu-icon">
                  <BriefcaseBusiness />
                </span>
                <span className="menu-text">Docentes</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/contacts",
                false,
              )} ${getMenuItemActive("/edit-contact", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/contacts">
                <span className="menu-icon">
                  <Mail />
                </span>
                <span className="menu-text">Contact</span>
              </NavLink>
            </li>
          </>
        )}

        <li
          className="menu-section"
          style={{ cursor: "pointer" }}
          onClick={() => toggleSection("congresos")}
        >
          <h4 className="menu-text">CONGRESOS</h4>
          {expandedSections.congresos ? (
            <i
              className="menu-icon ki ki-bold-triangle-top icon-sm"
              style={{ display: "flex", marginLeft: "auto" }}
            ></i>
          ) : (
            <i
              className="menu-icon ki ki-bold-triangle-bottom icon-sm"
              style={{ display: "flex", marginLeft: "auto" }}
            ></i>
          )}
        </li>
        {expandedSections.congresos && (
          <>
            <li
              className={`menu-item ${getMenuItemActive("/congresos", false, [
                "/congresos/sitio-web",
              ])} ${getMenuItemActive("/edit-congreso-edicion", false)} ${getMenuItemActive(
                "/ver-congreso-edicion",
                false,
              )}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/congresos">
                <span className="menu-icon">
                  <GroupWork />
                </span>
                <span className="menu-text">Ediciones</span>
              </NavLink>
            </li>
            <li className={`menu-item ${getMenuItemActive("/congresos/sitio-web", false)}`}>
              <NavLink className="menu-link" to="/congresos/sitio-web">
                <span className="menu-icon">
                  <LinkIcon />
                </span>
                <span className="menu-text">URL web congresos</span>
              </NavLink>
            </li>
          </>
        )}

        <li
          className="menu-section"
          style={{ cursor: "pointer" }}
          onClick={() => toggleSection("contenido")}
        >
          <h4 className="menu-text">CONTENIDO</h4>
          {expandedSections.contenido ? (
            <i
              className="menu-icon ki ki-bold-triangle-top icon-sm"
              style={{ display: "flex", marginLeft: "auto" }}
            ></i>
          ) : (
            <i
              className="menu-icon ki ki-bold-triangle-bottom icon-sm"
              style={{ display: "flex", marginLeft: "auto" }}
            ></i>
          )}
        </li>
        {expandedSections.contenido && (
          <>
            <li
              className={`menu-item ${getMenuItemActive(
                "/empleos",
                false,
              )} ${getMenuItemActive("/edit-empleo", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/empleos">
                <span className="menu-icon">
                  <Search />
                </span>
                <span className="menu-text">Empleos</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/calendario-cursos",
                false,
              )} `}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/calendario-cursos">
                <span className="menu-icon">
                  <Event />
                </span>
                <span className="menu-text">Calendario</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/eventos",
                false,
              )} ${getMenuItemActive("/edit-evento", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/eventos">
                <span className="menu-icon">
                  <EventAvailable />
                </span>
                <span className="menu-text">Eventos</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/cursos",
                false,
              )} ${getMenuItemActive("/edit-curso", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/cursos">
                <span className="menu-icon">
                  <School />
                </span>
                <span className="menu-text">Cursos</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/formaciones-personalizadas",
                false,
              )} ${getMenuItemActive("/edit-formacion-personalizada", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/formaciones-personalizadas">
                <span className="menu-icon">
                  <School />
                </span>
                <span className="menu-text">Formaciones personalizadas</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/intereses-formaciones",
                false,
              )}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/intereses-formaciones">
                <span className="menu-icon">
                  <Mail />
                </span>
                <span className="menu-text">Interesados</span>
              </NavLink>
            </li>

            <li
              className={`menu-item ${getMenuItemActive(
                "/certificados",
                false,
              )} ${getMenuItemActive("/edit-certificado", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/certificados">
                <span className="menu-icon">
                  <Stamp />
                </span>
                <span className="menu-text">Certificados</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/junta-directiva",
                false,
              )} ${getMenuItemActive("/edit-junta-directiva", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/junta-directiva">
                <span className="menu-icon">
                  <SupervisorAccount />
                </span>
                <span className="menu-text">Junta Directiva</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/acuerdo-colaboracion",
                false,
              )} ${getMenuItemActive("/edit-acuerdo-colaboracion", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/acuerdo-colaboracion">
                <span className="menu-icon">
                  <BriefcaseBusiness />
                </span>
                <span className="menu-text">Acuerdos de Colaboración</span>
              </NavLink>
            </li>
            {showBannersImagenesMenu(user.role) && (
              <>
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/banners",
                    false,
                  )} ${getMenuItemActive("/edit-banner", false)}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/banners">
                    <span className="menu-icon">
                      <Flag />
                    </span>
                    <span className="menu-text">Banners</span>
                  </NavLink>
                </li>
                {/*  <li 
                   className={`menu-item ${getMenuItemActive(
                     "/knowledges",
                     false
                   )} ${getMenuItemActive("/edit-knowledge", false)}`}
                   aria-haspopup="true"
                 >
                <NavLink className="menu-link" to="/knowledges">
                     <span className="menu-icon">
                       <Help />
                     </span>
                     <span className="menu-text">Knowledges</span>
                   </NavLink>
                 </li> */}
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/imagenes",
                    false,
                  )} ${getMenuItemActive("/edit-imagen", false)}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/imagenes">
                    <span className="menu-icon">
                      <Image />
                    </span>
                    <span className="menu-text">Imágenes y Archivos</span>
                  </NavLink>
                </li>
              </>
            )}
          </>
        )}

        <li
          className="menu-section"
          style={{ cursor: "pointer" }}
          onClick={() => toggleSection("noticias")}
        >
          <h4 className="menu-text">NOTICIAS</h4>
          {expandedSections.noticias ? (
            <i
              className="menu-icon ki ki-bold-triangle-top icon-sm"
              style={{ display: "flex", marginLeft: "auto" }}
            ></i>
          ) : (
            <i
              className="menu-icon ki ki-bold-triangle-bottom icon-sm"
              style={{ display: "flex", marginLeft: "auto" }}
            ></i>
          )}
        </li>
        {expandedSections.noticias && (
          <>
            <li
              className={`menu-item ${getMenuItemActive(
                "/newsletters",
                false,
              )} ${getMenuItemActive("/edit-newsletter", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/newsletters">
                <span className="menu-icon">
                  <BookOpenText />
                </span>
                <span className="menu-text">Mailings</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/noticias",
                false,
              )} ${getMenuItemActive("/edit-noticia", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/noticias">
                <span className="menu-icon">
                  <Newspaper />
                </span>
                <span className="menu-text">Noticias</span>
              </NavLink>
            </li>
            {/* <li
              className={`menu-item ${getMenuItemActive(
                "/mailings",
                false
              )} ${getMenuItemActive("/edit-mailing", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/mailings">
                <span className="menu-icon">
                  <ContactMail />
                </span>
                <span className="menu-text">Mailing</span>
              </NavLink>
            </li> */}
            <li
              className={`menu-item ${getMenuItemActive(
                "/categorias",
                false,
              )} ${getMenuItemActive("/edit-categoria", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/categorias">
                <span className="menu-icon">
                  <Category />
                </span>
                <span className="menu-text">Categorias</span>
              </NavLink>
            </li>
          </>
        )}

        <li
          className="menu-section"
          style={{ cursor: "pointer" }}
          onClick={() => toggleSection("miscellany")}
        >
          <h4 className="menu-text">MISCELLANY</h4>
          {expandedSections.miscellany ? (
            <i
              className="menu-icon ki ki-bold-triangle-top icon-sm"
              style={{ display: "flex", marginLeft: "auto" }}
            ></i>
          ) : (
            <i
              className="menu-icon ki ki-bold-triangle-bottom icon-sm"
              style={{ display: "flex", marginLeft: "auto" }}
            ></i>
          )}
        </li>
        {expandedSections.miscellany && showMiscConfigMenu(user.role) && (
            <>
              <li
                className={`menu-item ${getMenuItemActive(
                  "/usertypes",
                  false,
                )} ${getMenuItemActive("/edit-usertype", false)}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/usertypes">
                  <span className="menu-icon">
                    <Person />
                  </span>
                  <span className="menu-text">Tipos de Usuarios</span>
                </NavLink>
              </li>

              <li
                className={`menu-item ${getMenuItemActive(
                  "/languages",
                  false,
                )} ${getMenuItemActive("/edit-language", false)}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/languages">
                  <span className="menu-icon">
                    <LanguageIcon />
                  </span>
                  <span className="menu-text">Languages</span>
                </NavLink>
              </li>
              <li
                className={`menu-item ${getMenuItemActive(
                  "/texts",
                  false,
                )} ${getMenuItemActive("/edit-text", false)}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/texts">
                  <span className="menu-icon">
                    <DescriptionIcon />
                  </span>
                  <span className="menu-text">Texts</span>
                </NavLink>
              </li>
              <li
                className={`menu-item ${getMenuItemActive(
                  "/literals",
                  false,
                )} ${getMenuItemActive("/edit-literal", false)}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/literals">
                  <span className="menu-icon">
                    <Label />
                  </span>
                  <span className="menu-text">Literales Web</span>
                </NavLink>
              </li>
              <li
                className={`menu-item ${getMenuItemActive(
                  "/paises",
                  false,
                )} ${getMenuItemActive("/edit-pais", false)}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/paises">
                  <span className="menu-icon">
                    <Public />
                  </span>
                  <span className="menu-text">Paises</span>
                </NavLink>
              </li>
              <li
                className={`menu-item ${getMenuItemActive(
                  "/provincias",
                  false,
                )} ${getMenuItemActive("/edit-provincia", false)}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/provincias">
                  <span className="menu-icon">
                    <Landscape />
                  </span>
                  <span className="menu-text">Provincias</span>
                </NavLink>
              </li>
              <li
                className={`menu-item ${getMenuItemActive(
                  "/localidades",
                  false,
                )} ${getMenuItemActive("/edit-localidad", false)}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/localidades">
                  <span className="menu-icon">
                    <LocationCity />
                  </span>
                  <span className="menu-text">Localidades</span>
                </NavLink>
              </li>
            </>
          )}
      </ul>

      {/* end::Menu Nav */}
    </>
  );
}
